export const API_BASE = process.env.OMNIPLATFORM_API;
export const API_PATH = 'employees';
export const SEATS_API_PATH = 'seats';
